import { render, staticRenderFns } from "./FullPageLoader.vue?vue&type=template&id=65d006e2&scoped=true"
import script from "./FullPageLoader.vue?vue&type=script&lang=js"
export * from "./FullPageLoader.vue?vue&type=script&lang=js"
import style0 from "./FullPageLoader.vue?vue&type=style&index=0&id=65d006e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d006e2",
  null
  
)

export default component.exports